import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { getLitWordCount } from './utils/litWordCount';
import '../../assets/css/home_statement.css';

const PHRASES = [
  { text: '300+ fisheries.', accent: true },
  { text: 'Every lake, live.', accent: false },
  { text: 'Booked in three taps,', accent: true },
  { text: 'with no account or phone calls needed.', accent: false },
];

const WORDS = PHRASES.flatMap(({ text, accent }) =>
  text.split(' ').map((word) => ({ word, accent }))
);

const wordColourClass = (accent, lit) => {
  if (!lit) {
    return 'grey-200';
  }
  return accent ? 'sb-blue-900' : 'grey-600';
};

function HomeStatement() {
  const paragraphRef = useRef(null);
  const reducedMotion = useReducedMotion();
  const [litCount, setLitCount] = useState(0);

  useEffect(() => {
    if (reducedMotion) {
      return undefined;
    }
    let frame = null;
    const updateLitCount = () => {
      frame = null;
      const { top, height } = paragraphRef.current.getBoundingClientRect();
      setLitCount(
        getLitWordCount({
          top,
          height,
          viewportHeight: window.innerHeight,
          wordCount: WORDS.length,
        })
      );
    };
    const scheduleUpdate = () => {
      if (frame === null) {
        frame = window.requestAnimationFrame(updateLitCount);
      }
    };

    scheduleUpdate();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    return () => {
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      window.cancelAnimationFrame(frame);
    };
  }, [reducedMotion]);

  const shownLitCount = reducedMotion ? WORDS.length : litCount;

  return (
    <section className='hst-section'>
      <p ref={paragraphRef} className='hst-statement gBold'>
        {WORDS.map(({ word, accent }, index) => (
          <span
            key={`${index}-${word}`}
            className={`hst-word ${wordColourClass(
              accent,
              index < shownLitCount
            )}`}
          >
            {word}{' '}
          </span>
        ))}
      </p>
    </section>
  );
}

export default HomeStatement;
